import axios from "axios";
import NProgress from "react-nprogress";
import { getError } from "./userActions";

NProgress.configure({ showSpinner: true, easing: "ease", speed: 500 });

export const getData = (url, success, fail) => {
	NProgress.start();
	return async (dispatch) => {
		try {
			const response = await axios.get(url);

			if (response) {
				dispatch(success(response.data));
				NProgress.done();
				NProgress.remove();
			}
		} catch (err) {
			console.log(err);
			dispatch(getError(err));
			// dispatch(fail(err))
			NProgress.remove();
		}
	};
};

//get data with bearer token
export const getDataWithToken = (url, done, fail) => {
	const token = sessionStorage.getItem("jwtToken");
	const bearerToken = "Bearer " + token;
	NProgress.start();
	return (dispatch) => {
		fetch(url, {
			method: "GET",
			credentials: "same-origin",
			headers: new Headers({
				"Content-Type": "application/json",
				Authorization: bearerToken,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.data) {
					NProgress.done();
					NProgress.remove();
					if (data.data) {
						dispatch(done(data.data));
					} else {
						dispatch(done(data));
					}
				}

				else {
					dispatch(fail(data));
					NProgress.remove();
				}
			})
			.catch((err) => {
				NProgress.done();
				dispatch(fail(err))
				NProgress.remove();
			});
	};
};

export const postData = (url, payload, success, fail) => {
	NProgress.start();

	return (dispatch) => {
		// dispatch(start());
		fetch(url, {
			method: "POST",
			body: JSON.stringify(payload),
			redirect: "follow",
			// credentials: 'same-origin',
			// //mode: 'no-cors',
			headers: new Headers({
				"Content-Type": "application/json",
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.error || data.errors) {
					dispatch(fail(data));
				} else {
					dispatch(success(data.data));
				}
				NProgress.done();
				NProgress.remove();
			})
			.catch((err) => {
				console.log(err);
				dispatch(fail(err));
				NProgress.done();
				NProgress.remove();
			});
	};
};

export const postDataWithToken = (url, payload, done, fail) => {
	const token = sessionStorage.getItem("jwtToken");
	const bearerToken = "Bearer " + token;
	NProgress.start();
	return (dispatch) => {
		fetch(url, {
			method: "POST",
			body: JSON.stringify(payload),
			credentials: "same-origin",
			headers: new Headers({
				"Content-Type": "application/json",
				Authorization: bearerToken,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data.data) {

					NProgress.done();
					dispatch(done(data.data));
					NProgress.remove();
				}
			})
			.catch((err) => {
				console.log(err);
				dispatch(fail(err));
				NProgress.done();
				NProgress.remove();
			});
	};
};

export const putDataWithToken = (url, payload, done, fail) => {
	const token = sessionStorage.getItem("jwtToken");
	const bearerToken = "Bearer " + token;
	NProgress.start();
	return (dispatch) => {
		fetch(url, {
			method: "PUT",
			body: JSON.stringify(payload),
			credentials: "same-origin",
			headers: new Headers({
				"Content-Type": "application/json",
				Authorization: bearerToken,
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				NProgress.done();
				NProgress.remove();
				if (data.data) {
					dispatch(done(data));
				}
				else {
					dispatch(fail(data));
				}
			})
			.catch((err) => {
				console.log(err);
				dispatch(fail(err));
				NProgress.done();
				NProgress.remove();
			});
	};
};
